import { useEffect, useRef, useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { Card } from "components/ui/card";
import { Button } from "components/ui/button";

interface RichEditorProps {
  content: any;
  onContentChange?: (content: string) => void;
}

export function RichEditor({ content, onContentChange }: RichEditorProps) {
  const editorRef = useRef<HTMLDivElement>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (editorRef.current && content) {
      // Parse HTML from markdown code block if present
      const htmlContent = parseHTMLFromMarkdown(content);
      editorRef.current.innerHTML = htmlContent;
    }
  }, [content]);

  const parseHTMLFromMarkdown = (text: string): string => {
    // Remove markdown code block syntax if present
    const htmlMatch = text.match(/```html\n?([\s\S]*?)\n?```/);
    if (htmlMatch) {
      return htmlMatch[1].trim();
    }
    return text;
  };

  const handleInput = () => {
    if (editorRef.current && onContentChange) {
      onContentChange(editorRef.current.innerHTML);
    }
  };

 

  return (
    <Card className="p-6 bg-white">
     

      <div
        ref={editorRef}
        contentEditable
        onInput={handleInput}
        className="  rounded-lg  focus:outline-none focus:ring-2 focus:ring-purple-500 prose max-w-none "
        style={{
          // Custom table styles for the rich editor
          WebkitUserModify: "read-write-plaintext-only",
        }}
      />

      <style>{`
        .prose table {
          width: 100%;
          border-collapse: collapse;
          margin: 1rem 0;
          font-size: 0.875rem;
        }
        .prose table th,
        .prose table td {
          border: 1px solid #e5e7eb;
          padding: 0.75rem;
          text-align: left;
        }
        .prose table thead {
          background-color: #f9fafb;
        }
        .prose table th {
          font-weight: 600;
          color: #111827;
        }
        .prose table tbody tr:hover {
          background-color: #f9fafb;
        }
        .prose table td[colspan] {
          text-align: center;
          font-weight: 600;
          background-color: #f3f4f6;
        }
      `}</style>
    </Card>
  );
}
